import { useStores } from '../../../hooks/use-stores';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/* Responsible for setup of conditional banners through banner store */
export const ConditionalBannerManager = () => {
  const { t } = useTranslation();
  const { connectionStore, bannerStore, settingsStore, batchStore, newAuthStore, locationsStore } = useStores();
  const plantName = locationsStore.currentPlant.description;
  const email = newAuthStore?.user?.email;
  const supportLink = `https://secure.logmeinrescue.com/Customer/Download.aspx?EntryID=185000112&name=${email}&comment1=CloudBatch&comment2=${plantName}`;

  useEffect(() => {
    bannerStore.addConditionalBanner(
      {
        id: 'offline-status',
        observableGetter: () => !connectionStore.isOnline,
        variant: 'warning',
        message: t('You are in Offline mode. There is no need to log out, you can continue loading concrete with Batch button (F7).'),
        expandedMessage: t(`
          When in offline mode, tickets will not arrive from ConcreteGo or any other 3rd party dispatch system.\n
          All changes will be uploaded to Sysdyne Servers after online connection has been re-established.
        `),
        dismissible: false,
      },
    );
    bannerStore.addConditionalBanner(
      {
        id: 'api-version-changed',
        observableGetter: () => settingsStore.isApiVersionIncompatible,
        variant: 'warning',
        message: t('Current version is incompatible with API.'),
        expandedMessage: t(`
          If a load is in progress, please finish loading the concrete before reloading the application.
        `),
        dismissible: false,
      },
    );
    bannerStore.addConditionalBanner(
      {
        id: 'new-version-available',
        observableGetter: () => batchStore.newVersionAvailable,
        variant: 'info',
        message: t('New version available.'),
        expandedMessage: t(`
          If a load is in progress, please finish loading the concrete before reloading the application.
        `),
        dismissible: false,
      },
    );
    bannerStore.addConditionalBanner(
      {
        id: 'proxy-update-required',
        observableGetter: () => batchStore.proxyRequireUpdate,
        variant: new Date().getDate() < 15 ? 'warning' : 'error',
        message: t('Proxy update required by Sept 25, 2026. '),
        expandedMessage: (
          <a href={supportLink} rel="noreferrer" target={'_blank'}>{t('Please log on to support to request new update during normal business hours to avoid any service interruptions.')}</a>
        ),
        dismissible: false,
      },
    );
  }, [bannerStore, connectionStore, settingsStore, batchStore, newAuthStore, locationsStore, supportLink, t]);

  return null;
};
